import { Button, Column, ComboBox, DatePicker, DatePickerInput, FileUploader, FluidForm, Form, FormLabel, Grid, Header, Icon, NumberInput, Row, Select, SelectItem, TextArea, TextInput, Tile, } from "carbon-components-react";
import { Heading, Section } from "carbon-components-react/lib/components/Heading";
import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Padding from "../../components/Padding";
import UIShell from "../../components/UIShell";
import { createFaq } from "../../redux/actions/faqAction";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function FaqFormPage({ isLoading }) {
  const history = useHistory()
  const dispatch = useDispatch()

  const [formContent, setFormContent] = useState({
    question: undefined,
    answer: undefined,
  })

  const [answer, setAnswer] = useState('');

  const submitForm = (e) => {
    e.preventDefault()

    const data = {
      question: formContent.question,
      answer: answer
    }

    dispatch(createFaq(data, (_data) => {
      history.push("/faqs")
    }))
  }

  return (
    <UIShell breadcrumbs={[
      { name: 'Home', link: "/" },
      { name: 'Faq', link: "/faqs" },
      { name: 'Create' }
    ]}>
      <Grid>
        <Row>
          <Column>
            <Tile>
              <Section style={{ margin: '1rem 0 4rem 0' }}>
                <Heading >Create Faq</Heading>
                <p>Description Create Faq</p>
              </Section>
              <Form onSubmit={submitForm}>
                <TextInput
                  labelText="Question"
                  value={formContent.question}
                  onChange={(v) => setFormContent((_state) => ({
                    ..._state,
                    question: v.target.value
                  }))}
                  style={{ marginBottom: '2rem' }}
                  light
                />
                <ReactQuill 
                  theme="snow" 
                  value={answer} 
                  onChange={setAnswer} 
                />
                <Padding top="1rem">
                  <Button disabled={isLoading} type="submit" kind="primary">Save</Button>
                  <Button onClick={() => history.push("/faqs")} kind="secondary">Cancel</Button>
                </Padding>
              </Form>
            </Tile>
          </Column>

        </Row>
      </Grid>

    </UIShell>
  )
}

const mapStateToProps = state => {
  return {
    isLoading: state.uxReducer.isLoading
  }
}

export default connect(mapStateToProps)(FaqFormPage)